"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrayQueryStringMapper = exports.objectToQueryString = exports.queryStringToObject = void 0;
const schema = __importStar(require("./queryStringSchema"));
__exportStar(require("./queryStringSchema"), exports);
/**
 * Parse a query string into an object using a predefined schema.
 *
 * @example
 * ```ts
 * interface Schema {
 *     text: string;
 *     value: number;
 * }
 *
 * const schema: QueryStringSchema<Schema> = {
 *     text: string(),
 *     value: number()
 * };
 *
 * const object = queryStringToObject('?text=abc&value=10', schema);
 * object.text // "abc"
 * ```
 *
 * @param queryString Query string to parse.
 * @param schemaObject Schema to use for the resulting object.
 * @returns An `object` with parsed values.
 */
function queryStringToObject(queryString, schemaObject) {
    const qs = queryString?.replace(/^\?+/g, '') ?? '';
    const res = {};
    for (let kv of qs.split('&')) {
        let [key, value] = kv.split('=');
        key = key ? decodeURIComponent(key.trim()) : '';
        if (!key) {
            continue;
        }
        value = value ? decodeURIComponent(value) : '';
        const schemaObj = schemaObject
            ? schemaObject[key]
            : schema.string();
        if (!schemaObj) {
            continue;
        }
        const handledValue = schemaObj.handle(key, value);
        if (handledValue != null) {
            res[key] = handledValue;
        }
    }
    return res;
}
exports.queryStringToObject = queryStringToObject;
/**
 * Serialize an object into a query string with only truthy values.
 *
 * @param obj Object to convert to a query string.
 * @param mapper Optional key/value mapper to use for each entry.
 * @returns A query string starting with '?'.
 */
function objectToQueryString(obj, mapper) {
    if (!obj) {
        return '';
    }
    return '?' + Object.keys(obj)
        .filter(key => !!obj[key])
        .map(key => {
        if (mapper) {
            const value = mapper.map(key, obj[key]);
            if (value != null) {
                return value;
            }
        }
        return `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`;
    })
        .join('&');
}
exports.objectToQueryString = objectToQueryString;
/**
 * A query mapper compatible with default enumerable type parameters in .net webapi.
 * The same key will be used for each value.
 */
exports.arrayQueryStringMapper = {
    map(key, value) {
        if (Array.isArray(value)) {
            return value.map(val => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`).join('&');
        }
        return null;
    }
};
//# sourceMappingURL=queryString.js.map